import React, { useEffect, ReactNode } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { resolveOrganization } from "./store/thunk";
import SplashScreen from "../../components/common/SplashScreen";
import { getDomainSlug } from "./utils/tenant";
import NotFoundPage from "../../components/errors/NotFound";

const SLUGS_SKIP_ORG_RESOLUTION = ["coach"];

export function OrgProvider({ children }: { children: ReactNode }) {
  const dispatch = useDispatch<AppDispatch>();
  const { status, resolvedSlug } = useSelector(
    (state: RootState) => state.organization,
  );

  const slug = getDomainSlug();

  useEffect(() => {
    if (!slug) return;
    if (SLUGS_SKIP_ORG_RESOLUTION.includes(slug)) return;

    if (status !== "idle" && resolvedSlug === slug) return;

    dispatch(resolveOrganization(slug));
  }, [dispatch, status, resolvedSlug, slug]);

  if (!slug) {
    return <NotFoundPage />;
  }

  // Loading org
  if (status === "loading") {
    return <SplashScreen />;
  }

  // Org fetch failed
  if (status === "failed") {
    return <NotFoundPage />;
  }

  return <>{children}</>;
}
